import { map } from 'rxjs/operators';
import { Injectable, QueryList, Inject } from '@angular/core';
import { BaseService } from '../core';
import { Inquiry, PurchaseOrder, Cart, Product } from '../dto';
import { Banner } from '../dto/banner/banner.entity';
import { INCOTERMS, REFUND_METHOD, PAYMENT_METHOD } from '../shared';
import { BANNER_TYPE } from '../shared/common-code.type';
import { BaseUser } from '../shared/auth/dto/base-user';
import { CategoryNamePipe } from '../common/pipes/category-name.pipe';
import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { ITranslationService, I18NEXT_SERVICE } from 'angular-i18next';
import { Router } from '@angular/router';

var __MOJI_checkout_list__;
var __MOJI_detail_imp__;

export interface ProductDataset {
  brand: string;
  category: string;
  id: number;
  list: string;
  name: string;
  position: number;
  price: number;
  variant: string;
}
export interface GA4ProductDataset {
  item_id: number;
  item_name: string;
  coupon: string;
  discount: number;
  index: number;
  item_brand: string;
  item_category: string;
  item_category2: string;
  item_category3: string;
  item_category4: string;
  item_category5: string;
  item_list_id: number;
  item_list_name: string;
  item_variant: string;
  price: number;
  quantity: number;
}
@Injectable({
  providedIn: 'root',
})
export class GaService extends BaseService {
  constructor(
    @Inject(I18NEXT_SERVICE) private i18NextService: ITranslationService,
    private router: Router,
    private categoryName: CategoryNamePipe,
    private gtmService: GoogleTagManagerService
  ) {
    super();
  }
  MOJI_Join() {
    // tslint:disable-next-line: no-string-literal
    if (window['__MOJI_CB__'] && window['__MOJI_CB__']['join_success']) window['__MOJI_CB__']['join_success']();
  }

  MOJI_AddToCart(cartList, from?: string) {
    let __MOJI_cart_list__ = [];
    let total = this.caculateCartsTotal(cartList);

    try {
      if (cartList.length > 1) {
        cartList.forEach((item) => {
          __MOJI_cart_list__.push({
            item_id: item.mapperSaleProduct.productOption.sku,
            item_name: item.mapperSaleProduct.product.englishName,
            index: item.mapperSaleProduct.product.id,
            item_brand: item.mapperSaleProduct.productOption.brand.englishName,
            item_category: this._getCategoryName(1, item.mapperSaleProduct.productOption.salesCategory.mpathName),
            item_category2: this._getCategoryName(2, item.mapperSaleProduct.productOption.salesCategory.mpathName),
            item_category3: this._getCategoryName(3, item.mapperSaleProduct.productOption.salesCategory.mpathName),
            item_category4: this._getCategoryName(4, item.mapperSaleProduct.productOption.salesCategory.mpathName),
            item_list_id: from,
            item_list_name: from,
            item_variant: item.mapperSaleProduct.productOption.englishOptionName,
            // price: item.mapperSaleProduct.productOption.salePriceUSD,
            // quantity: item.quantity,
          });
        });
        // tslint:disable-next-line:only-arrow-functions
      } else {
        if (cartList[0]) {
          __MOJI_cart_list__ = [
            {
              item_id: cartList[0].mapperSaleProduct.productOption.sku,
              item_name: cartList[0].mapperSaleProduct.product.englishName,
              index: cartList[0].mapperSaleProduct.product.id,
              item_brand: cartList[0].mapperSaleProduct.productOption.brand.englishName,
              item_category: this._getCategoryName(
                1,
                cartList[0].mapperSaleProduct.productOption.salesCategory.mpathName
              ),
              item_category2: this._getCategoryName(
                2,
                cartList[0].mapperSaleProduct.productOption.salesCategory.mpathName
              ),
              item_category3: this._getCategoryName(
                3,
                cartList[0].mapperSaleProduct.productOption.salesCategory.mpathName
              ),
              item_category4: this._getCategoryName(
                4,
                cartList[0].mapperSaleProduct.productOption.salesCategory.mpathName
              ),
              item_list_id: from,
              item_list_name: from,
              item_variant: cartList[0].mapperSaleProduct.productOption.englishOptionName,
              // price: cartList[0].mapperSaleProduct.productOption.salePriceUSD,
              // quantity: cartList[0].quantity,
            },
          ];
        }
      }
      this.gtmService.pushTag({ ecommerce: null });
      this.gtmService.pushTag({
        event: 'add_to_cart',
        ecommerce: {
          currency: 'USD',
          value: total.summary,
          items: __MOJI_cart_list__,
        },
      });
    } catch (error) {}
  }

  MOJI_Inquiry(inquiry: Inquiry) {
    if (window['__MOJI_CB__'] && window['__MOJI_CB__']['inquiry_form_submit_success'])
      // tslint:disable-next-line: no-string-literal
      window['__MOJI_CB__']['inquiry_form_submit_success'](inquiry);
  }

  MOJI_Order_Complete(order: PurchaseOrder) {
    // tslint:disable-next-line:no-var-keyword
    let __MOJI_purchase_list__ = [];
    try {
      order.products.forEach((item) => {
        __MOJI_purchase_list__.push({
          item_id: item.mapperSaleProduct.productOption.sku,
          item_name: item.mapperSaleProduct.product.englishName,
          index: item.mapperSaleProduct.product.id,
          item_brand: item.mapperSaleProduct.productOption.brand.englishName,
          item_category: this._getCategoryName(1, item.mapperSaleProduct.productOption.salesCategory.mpathName),
          item_category2: this._getCategoryName(2, item.mapperSaleProduct.productOption.salesCategory.mpathName),
          item_category3: this._getCategoryName(3, item.mapperSaleProduct.productOption.salesCategory.mpathName),
          item_category4: this._getCategoryName(4, item.mapperSaleProduct.productOption.salesCategory.mpathName),
          item_variant: item.mapperSaleProduct.productOption.englishOptionName,
          price: item.salePriceUSD,
          quantity: item.quantity,
        });
      });
      order.sampleProducts.forEach((item) => {
        __MOJI_purchase_list__.push({
          item_id: item.campaignSettingMapperSampleProduct.sampleProduct.sku,
          item_name: item.campaignSettingMapperSampleProduct.sampleProduct.englishName,
          index: item.campaignSettingMapperSampleProduct.sampleProduct.id,
          item_brand: item.campaignSettingMapperSampleProduct.sampleProduct.brand.englishName,
          item_category: this.categoryName.transform(
            item.campaignSettingMapperSampleProduct.sampleProduct.salesCategoryCode
          ),
          item_variant: item.campaignSettingMapperSampleProduct.sampleProduct.englishOptionName,
          price: 0,
          quantity: item.campaignSettingMapperSampleProduct.sampleProduct.inboxQuantity * item.selectedCount,
          promotion_id: item.campaignSettingMapperSampleProduct.campaignSetting.id,
          promotion_name: item.campaignSettingMapperSampleProduct.campaignSetting.name,
        });
      });
      this.gtmService.pushTag({ ecommerce: null });
      this.gtmService.pushTag({
        event: 'purchase',
        ecommerce: {
          transaction_id: order.orderNumber,
          value: order.purchasePrice,
          tax: '',
          shipping: order.shippingFee,
          currency: 'USD',
          coupon: order.buyerCoupon ? order.buyerCoupon.couponSetting.name : '',
          items: __MOJI_purchase_list__,
        },
      });

      // tslint:disable-next-line:only-arrow-functions
      // (function (d) {
      //   try {
      //     // tslint:disable-next-line: no-string-literal
      //     if (window['__MOJI_CB__'] && window['__MOJI_CB__']['purchase']) window['__MOJI_CB__']['purchase'](d);
      //   } catch (err) {}
      // })(__MOJI_purchase__);
    } catch (error) {}
  }

  MOJI_Checkout(carts: Cart[]) {
    let __MOJI_checkout_list__ = [];
    let total = this.caculateCartsTotal(carts);

    try {
      carts.forEach((item) => {
        __MOJI_checkout_list__.push({
          item_id: item.mapperSaleProduct.productOption.sku,
          item_name: item.mapperSaleProduct.product.englishName,
          index: item.mapperSaleProduct.product.id,
          item_brand: item.mapperSaleProduct.productOption.brand.englishName,
          item_category: this._getCategoryName(1, item.mapperSaleProduct.productOption.salesCategory.mpathName),
          item_category2: this._getCategoryName(2, item.mapperSaleProduct.productOption.salesCategory.mpathName),
          item_category3: this._getCategoryName(3, item.mapperSaleProduct.productOption.salesCategory.mpathName),
          item_category4: this._getCategoryName(4, item.mapperSaleProduct.productOption.salesCategory.mpathName),
          item_variant: item.mapperSaleProduct.productOption.englishOptionName,
          // price: item.mapperSaleProduct.productOption.salePriceUSD,
          // quantity: item.quantity,
        });
      });
      this.gtmService.pushTag({ ecommerce: null });
      this.gtmService.pushTag({
        event: 'view_cart',
        ecommerce: {
          currency: 'USD',
          value: total.summary,
          items: __MOJI_checkout_list__,
        },
      });
      // tslint:disable-next-line:only-arrow-functions
      // (function (d) {
      //   try {
      //     // tslint:disable-next-line:no-string-literal
      //     if (window['__MOJI_CB__'] && window['__MOJI_CB__']['checkout']) window['__MOJI_CB__']['checkout'](d);
      //   } catch (err) {}
      // })(__MOJI_checkout_list__);
    } catch (error) {}
  }

  MOJI_Add_Payment_Info(carts: Cart[], paymentMethod?: PAYMENT_METHOD) {
    let __MOJI_payment_list__ = [];
    let total = this.caculateCartsTotal(carts);

    try {
      carts.forEach((item) => {
        __MOJI_payment_list__.push({
          item_id: item.mapperSaleProduct.productOption.sku,
          item_name: item.mapperSaleProduct.product.englishName,
          index: item.mapperSaleProduct.product.id,
          item_brand: item.mapperSaleProduct.productOption.brand.englishName,
          item_category: this._getCategoryName(1, item.mapperSaleProduct.productOption.salesCategory.mpathName),
          item_category2: this._getCategoryName(2, item.mapperSaleProduct.productOption.salesCategory.mpathName),
          item_category3: this._getCategoryName(3, item.mapperSaleProduct.productOption.salesCategory.mpathName),
          item_category4: this._getCategoryName(4, item.mapperSaleProduct.productOption.salesCategory.mpathName),
          item_variant: item.mapperSaleProduct.productOption.englishOptionName,
          // price: item.mapperSaleProduct.productOption.salePriceUSD,
          // quantity: item.quantity,
        });
      });
      this.gtmService.pushTag({ ecommerce: null });
      this.gtmService.pushTag({
        event: 'add_payment_info',
        ecommerce: {
          currency: 'USD',
          value: total.summary,
          payment_type: paymentMethod,
          items: __MOJI_payment_list__,
        },
      });
      // tslint:disable-next-line:only-arrow-functions
      // (function (d) {
      //   try {
      //     // tslint:disable-next-line:no-string-literal
      //     if (window['__MOJI_CB__'] && window['__MOJI_CB__']['checkout']) window['__MOJI_CB__']['checkout'](d);
      //   } catch (err) {}
      // })(__MOJI_checkout_list__);
    } catch (error) {}
  }

  MOJI_Checkout_option(shippingMethod?: INCOTERMS, paymentMethod?: PAYMENT_METHOD, refundMethod?: REFUND_METHOD) {
    // tslint:disable-next-line:variable-name
    // tslint:disable-next-line: no-var-keyword
    var __MOJI_checkout_option__;
    if (shippingMethod) {
      __MOJI_checkout_option__ = [shippingMethod];
    } else {
      __MOJI_checkout_option__ = [paymentMethod, refundMethod];
    }

    // tslint:disable-next-line:only-arrow-functions
    (function (d) {
      try {
        // tslint:disable-next-line:no-string-literal
        if (window['__MOJI_CB__'] && window['__MOJI_CB__']['checkout_opt'])
          // tslint:disable-next-line:no-string-literal
          window['__MOJI_CB__']['checkout_opt'](d);
      } catch (err) {}
    })(__MOJI_checkout_option__);
  }

  MOJI_Login(user: BaseUser) {
    sessionStorage.setItem('MOJI_USER_ID', `${user.userId}`);
    // tslint:disable-next-line:only-arrow-functions
    (function (d) {
      try {
        // tslint:disable-next-line:no-string-literal
        if (window['__MOJI_CB__'] && window['__MOJI_CB__']['login']) window['__MOJI_CB__']['login'](d);
      } catch (err) {}
    })();
  }

  MOJI_Logout() {
    sessionStorage.removeItem('MOJI_USER_ID');
    // tslint:disable-next-line:only-arrow-functions
    (function (d) {
      try {
        // tslint:disable-next-line:no-string-literal
        if (window['__MOJI_CB__'] && window['__MOJI_CB__']['logout']) window['__MOJI_CB__']['logout'](d);
      } catch (err) {}
    })();
  }

  MOJI_ProductList(productRef: QueryList<any>) {
    let products;
    productRef.changes.subscribe((ref) => {
      products = ref.toArray().map((item) => item.product);
      if (productRef.length) {
        (function (d) {
          try {
            // tslint:disable-next-line: no-string-literal
            if (window['__MOJI_CB__'] && window['__MOJI_CB__']['product_impression'])
              // tslint:disable-next-line:no-string-literal
              window['__MOJI_CB__']['product_impression'](d);
          } catch (err) {}
        })(products);
      }
    });
  }

  MOJI_ProductDetail(product: Product, dataset: ProductDataset) {
    this.gtmService.pushTag({ ecommerce: null });
    this.gtmService.pushTag({
      event: 'select_item',
      ecommerce: {
        item_list_id: dataset.list,
        item_list_name: dataset.list,
        items: [
          {
            item_id: product.id,
            item_name: product.englishName,
            index: 0,
            item_brand: product.brand.englishName,
            item_category: this._getCategoryName(
              1,
              product.mapperSaleProducts[0].productOption.salesCategory.mpathName
            ),
            item_category2: this._getCategoryName(
              2,
              product.mapperSaleProducts[0].productOption.salesCategory.mpathName
            ),
            item_category3: this._getCategoryName(
              3,
              product.mapperSaleProducts[0].productOption.salesCategory.mpathName
            ),
            item_category4: this._getCategoryName(
              4,
              product.mapperSaleProducts[0].productOption.salesCategory.mpathName
            ),
            item_list_id: dataset.list,
            item_list_name: dataset.list,
            item_variant: product.mapperSaleProducts[0].productOption.englishOptionName,
            // price: product.mapperSaleProducts[0].productOption.salePriceUSD,
          },
        ],
      },
    });
    // this.gtmService.pushTag({
    //   event: 'view_item',
    //   ecommerce: {
    //     item_list_id: dataset.list,
    //     item_list_name: dataset.list,
    //     items: [
    //       {
    //         item_id: product.id,
    //         item_name: product.englishName,
    //         index: 0,
    //         item_brand: product.brand.englishName,
    //         item_category: this._getCategoryName(
    //           1,
    //           product.mapperSaleProducts[0].productOption.salesCategory.mpathName
    //         ),
    //         item_category2: this._getCategoryName(
    //           2,
    //           product.mapperSaleProducts[0].productOption.salesCategory.mpathName
    //         ),
    //         item_category3: this._getCategoryName(
    //           3,
    //           product.mapperSaleProducts[0].productOption.salesCategory.mpathName
    //         ),
    //         item_category4: this._getCategoryName(
    //           4,
    //           product.mapperSaleProducts[0].productOption.salesCategory.mpathName
    //         ),
    //         item_list_id: dataset.list,
    //         item_list_name: dataset.list,
    //         item_variant: product.mapperSaleProducts[0].productOption.englishOptionName,
    //         // price: product.mapperSaleProducts[0].productOption.salePriceUSD,
    //       },
    //     ],
    //   },
    // });
    // __MOJI_detail_imp__ = {
    //   actionField: {
    //     list: dataset.list,
    //   },
    //   products: [],
    // };
    // try {
    //   __MOJI_detail_imp__.products = product.mapperSaleProducts.map((mapperSaleProduct) => {
    //     return {
    //       name: product.englishName,
    //       id: product.id,
    //       price: mapperSaleProduct.productOption.salePriceUSD,
    //       brand: product.brand.englishName,
    //       category: dataset.category,
    //       variant: mapperSaleProduct.productOption.englishOptionName,
    //     };
    //   });
    //   // tslint:disable-next-line:only-arrow-functions
    //   (function (d) {
    //     try {
    //       // tslint:disable-next-line:no-string-literal
    //       if (window['__MOJI_CB__'] && window['__MOJI_CB__']['product_detail_impression'])
    //         // tslint:disable-next-line:no-string-literal
    //         window['__MOJI_CB__']['product_detail_impression'](d);
    //     } catch (err) {}
    //   })(__MOJI_detail_imp__);
    // } catch (error) {}
  }

  onClickBanner(banner: Banner, isDesktop?) {
    switch (banner.bannerType) {
      case BANNER_TYPE.TOP:
        this.gtmService.pushTag({
          event: 'gaEvent',
          category: 'home',
          action: 'Click Visual Banner',
          label: `Click Visual Banner [${banner.id}]`,
        });
        break;
      case BANNER_TYPE.MIDDLE1:
        this.gtmService.pushTag({
          event: 'gaEvent',
          category: 'home',
          action: 'Click Middle1 Banner',
          label: `Click Middle1 Banner [${banner.id}]`,
        });
        break;
      case BANNER_TYPE.MIDDLE2:
        this.gtmService.pushTag({
          event: 'gaEvent',
          category: 'home',
          action: 'Click Middle2 Banner',
          label: `Click Middle2 Banner [${banner.id}]`,
        });
        break;
      case BANNER_TYPE.BOTTOM:
        this.gtmService.pushTag({
          event: 'gaEvent',
          category: 'home',
          action: 'Click Bottom Banner',
          label: `Click Bottom Banner [${banner.id}]`,
        });
    }
    if (!banner.data[this.i18NextService.language].url) {
      this.router.navigate(['/brand', banner.bannerSetting.brandId]);
    } else {
      if (isDesktop) {
        window.open(banner.data[this.i18NextService.language].url, '_blank');
      } else {
        window.location.href = banner.data[this.i18NextService.language].url;
      }
    }
  }

  goToProductDetail(dataset?: any, type?: string, product?: Product, isDesktop?: boolean) {
    this.gtmService.pushTag({ ecommerce: null });
    this.gtmService.pushTag({
      event: 'view_item_list',
      ecommerce: {
        item_list_id: type,
        item_list_name: type,
        items: [
          {
            item_id: product.id,
            item_name: product.englishName,
            index: 0,
            item_brand: product.brand.englishName,
            item_category: this._getCategoryName(
              1,
              product.mapperSaleProducts[0].productOption.salesCategory.mpathName
            ),
            item_category2: this._getCategoryName(
              2,
              product.mapperSaleProducts[0].productOption.salesCategory.mpathName
            ),
            item_category3: this._getCategoryName(
              3,
              product.mapperSaleProducts[0].productOption.salesCategory.mpathName
            ),
            item_category4: this._getCategoryName(
              4,
              product.mapperSaleProducts[0].productOption.salesCategory.mpathName
            ),
            item_list_id: type,
            item_list_name: type,
            item_variant: product.mapperSaleProducts[0].productOption.englishOptionName,
            // location_id:
            // price: product.mapperSaleProducts[0].productOption.salePriceUSD,
          },
        ],
      },
    });

    // switch (type) {
    //   case 'newArrival':
    //     this.gtmService.pushTag({
    //       event: 'view_item_list',
    //       ecommerce: {
    //         item_list_id: 'newArrival',
    //         item_list_name: 'newArrival',
    //         items: [
    //           {
    //             item_id: product.id,
    //             item_name: product.englishName,
    //             affiliation: 'UMMA',
    //             index: 0,
    //             item_brand: product.brand.englishName,
    //             item_category: this._getCategoryName(
    //               1,
    //               product.mapperSaleProducts[0].productOption.salesCategory.mpathName
    //             ),
    //             item_category2: this._getCategoryName(
    //               2,
    //               product.mapperSaleProducts[0].productOption.salesCategory.mpathName
    //             ),
    //             item_category3: this._getCategoryName(
    //               3,
    //               product.mapperSaleProducts[0].productOption.salesCategory.mpathName
    //             ),
    //             item_category4: this._getCategoryName(
    //               4,
    //               product.mapperSaleProducts[0].productOption.salesCategory.mpathName
    //             ),
    //             item_category5: '',
    //             item_list_id: 'newArrival',
    //             item_list_name: 'newArrival',
    //             item_variant: product.mapperSaleProducts[0].productOption.englishOptionName,
    //             location_id: '',
    //             price: product.mapperSaleProducts[0].productOption.salePriceUSD,
    //             quantity: 0,
    //             promotion_id: '',
    //             promotion_name: '',
    //           },
    //         ],
    //       },
    //     });
    //     break;
    //   case 'brand':
    //     this.gtmService.pushTag({
    //       event: 'view_item_list',
    //       ecommerce: {
    //         item_list_id: 'brand',
    //         item_list_name: 'brand',

    //         items: [
    //           {
    //             item_id: product.mapperSaleProducts[0].productOption.sku,
    //             item_name: product.englishName,
    //             affiliation: 'UMMA',
    //             coupon: '',
    //             discount: 0,
    //             index: 0,
    //             item_brand: product.brand.englishName,
    //             item_category: this._getCategoryName(
    //               1,
    //               product.mapperSaleProducts[0].productOption.salesCategory.mpathName
    //             ),
    //             item_category2: this._getCategoryName(
    //               2,
    //               product.mapperSaleProducts[0].productOption.salesCategory.mpathName
    //             ),
    //             item_category3: this._getCategoryName(
    //               3,
    //               product.mapperSaleProducts[0].productOption.salesCategory.mpathName
    //             ),
    //             item_category4: this._getCategoryName(
    //               4,
    //               product.mapperSaleProducts[0].productOption.salesCategory.mpathName
    //             ),
    //             item_category5: '',
    //             item_list_id: 'brand',
    //             item_list_name: 'brand',
    //             item_variant: product.mapperSaleProducts[0].productOption.englishOptionName,
    //             location_id: 'ChIJIQBpAG2ahYAR_6128GcTUEo',
    //             price: product.mapperSaleProducts[0].productOption.salePriceUSD,
    //             quantity: 0,
    //           },
    //         ],
    //       },
    //     });
    //     break;
    //   case 'best':
    //     this.gtmService.pushTag({
    //       event: 'gaEvent',
    //       category: 'home',
    //       action: 'Click Best product',
    //       label: `Product Name : ${product.englishName}`,
    //       data: product.id,
    //     });
    //     break;
    //   case 'umma_pick':
    //     this.gtmService.pushTag({
    //       event: 'gaEvent',
    //       category: 'home',
    //       action: `Click Umma's pick product`,
    //       label: `Product Name : ${product.englishName}`,
    //       data: product.id,
    //     });
    //     break;
    //   case 'slot_top':
    //     this.gtmService.pushTag({
    //       event: 'gaEvent',
    //       category: 'home',
    //       action: `Click slot top product`,
    //       label: `Product Name : ${product.englishName}`,
    //       data: product.id,
    //     });
    //     break;
    //   case 'slot_bottom':
    //     this.gtmService.pushTag({
    //       event: 'gaEvent',
    //       category: 'home',
    //       action: `Click slot bottom product`,
    //       label: `Product Name : ${product.englishName}`,
    //       data: product.id,
    //     });
    //     break;
    // }

    if (isDesktop) {
      this.openInNewTab(this.router, `/product/${product.id}`, { state: { dataset } });
    } else {
      this.router.navigateByUrl(`/product/${product.id}`, { state: { dataset } });
    }
    // this.router.navigateByUrl(`/product/${product.id}`, { state: { dataset } });
  }

  openInNewTab(router: Router, namedRoute, dataset?: any) {
    const newRelativeUrl = router.createUrlTree([namedRoute], { queryParams: { dataset } });
    const baseUrl = decodeURIComponent(window.location.href).replace(decodeURIComponent(router.url), '');
    console.log(baseUrl, newRelativeUrl, baseUrl + newRelativeUrl);
    window.open(baseUrl + newRelativeUrl, '_blank');
  }

  protected _getCategoryName(depth: number, mpathName: string) {
    if (depth === 1) {
      return mpathName.split('||')[0] || '';
    } else if (depth === 2) {
      return mpathName.split('||')[1] || '';
    } else if (depth === 3) {
      return mpathName.split('||')[2] || '';
    } else if (depth === 4) {
      return mpathName.split('||')[3] || '';
    } else {
      return '';
    }
  }

  private caculateCartsTotal(carts: Cart[]) {
    return carts.reduce(
      (acc, cur) => {
        acc.summary = this.getPointToFixed(
          Number(acc.summary + cur.mapperSaleProduct.productOption.salePriceUSD * cur.quantity)
        );
        acc.quantity = acc.quantity + cur.quantity;
        return acc;
      },
      { summary: 0, quantity: 0 }
    );
  }

  private getPointToFixed(num: number) {
    // 소수점 3자리에서 반올림 (1.265 => 1.27)
    return Math.round(num * 100) / 100;
  }
}
